import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Config, TypDataEnvironment } from './config.interface';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: Config;

  constructor(private http: HttpClient) { }

  loadConfig(): Observable<void> {
    return this.http.get<Config>('../../../assets/config/config.json').pipe(
      map(config => {
        this.config = config;
      })
    );
  }

  get domain(): string {
    return this.config.domain;
  }

  get secure(): boolean {
    return this.config.secure;
  }

  get loatWebBackend(): string {
    return this.config.loat_web_backend;
  }

  get login(): string {
    return this.config.loat_web_backend + this.config.login;
  }

  get forcedLogin(): string {
    return this.config.loat_web_backend + this.config.forced_login;
  }

  get segeditProfile(): string {
    return this.config.loat_web_backend + this.config.segedit_profile;
  }

  get profile(): string {
    return this.config.loat_web_backend + this.config.profile;
  }

  get facilityList(): string {
    return this.config.loat_web_backend + this.config.facility_list;
  }

  get tableConfig(): string {
    return this.config.loat_web_backend + this.config.table_config;
  }

  get mainList(): string {
    return this.config.loat_web_backend + this.config.main_list;
  }

  get eventListAccept(): string {
    return this.config.loat_web_backend + this.config.event_list_accept;
  }

  get eventListSend(): string {
    return this.config.loat_web_backend + this.config.event_list_send;
  }

  get eventListUndo(): string {
    return this.config.loat_web_backend + this.config.event_list_undo;
  }

  get eventListNotifications(): string {
    return this.config.loat_web_backend + this.config.event_list_notifications;
  }

  get eventSegeditNotifications(): string {
    return this.config.loat_web_backend + this.config.event_segedit_notifications;
  }

  get secondaryList(): string {
    return this.config.loat_web_backend + this.config.secondary_list;
  }

  get users(): string {
    return this.config.loat_web_backend + this.config.users;
  }

  get typConfig(): string {
    return this.config.loat_web_backend + this.config.typ_config;
  }

  get userTyp(): string {
    return this.config.loat_web_backend + this.config.user_typ;
  }

  get typDataEnvironment(): TypDataEnvironment[] {
    return this.config.typ_data_enviroment;
  }

  get segEditUrl(): string {
    return this.config.segedit_web_url;
  }

  get segEditTimeOut(): number {
    return this.config.segedit_web_session_out;
  }

  get version(): string {
    return this.config.version;
  }
}
